import { FilterOptionKeys } from '@griply/types';
import { TFunction } from 'i18next';
import { Calendar } from 'shared/assets/icons';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { FilterDateRangeOption, FilterOptionType } from 'shared/types/filter';
import { WeekDays } from 'shared/types/week-days';

export type Options = {
  t: TFunction;
  dateFormat: DateFormatOptions;
  weekStartsOn: WeekDays;
};

export const createDateFilter = ({
  t,
  dateFormat,
  weekStartsOn,
}: Options): FilterDateRangeOption => ({
  id: FilterOptionKeys.Date,
  label: t('context-menus.filtering.task.filters.date.due-date.title'),
  icon: Calendar,
  type: FilterOptionType.DateRange,
  dateFormat,
  weekStartsOn,
  canReset: true,
});
